// @charset "utf-8"
import Vue from 'vue'
import confirmVue from '@/components/lib/confirm'

// import { PopupManager } from 'element-ui/src/utils/popup'
// import { isVNode } from 'element-ui/src/utils/vdom',
var ConfirmConstructor = Vue.extend(confirmVue)

var instance
var instances = []
var seed = 1

var Confirm = function (options) {
    if (Vue.prototype.$isServer) {
        return
    }
    options = options || {}
    if (typeof options === 'string') {
        options = {
            tip: options
        }
    }
    var userOnClose = options.onClose
    var id = 'confirm_' + seed++

    options.onClose = function () {
        Confirm.close(id, userOnClose)
    }
    instance = new ConfirmConstructor({
        data: options
    })
    instance.id = id
    // if (isVNode(instance.tip)) {
    //   instance.$slots.default = [instance.tip]
    //   instance.tip = null
    // }
    instance.vm = instance.$mount()
    document.body.appendChild(instance.vm.$el)
    instance.vm.visible = true
    instance.dom = instance.vm.$el
    // instance.dom.style.zIndex = PopupManager.nextZIndex()
    instances.push(instance)
    return instance.vm
}

Confirm.close = function (id, userOnClose) {
    for (var i = 0, len = instances.length; i < len; i++) {
        if (id === instances[i].id) {
            if (typeof userOnClose === 'function') {
                userOnClose(instances[i])
            }
            instances.splice(i, 1)
            break
        }
    }
}

Confirm.closeAll = function () {
    for (var i = instances.length - 1; i >= 0; i--) {
        instances[i].close()
    }
}

export default Confirm



// WEBPACK FOOTER //
// ./src/lib/confirmVue.js